import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';

@Injectable({
    providedIn: 'root'
})
export class LoaderService {

    loader: HTMLIonLoadingElement;

    constructor(
        private loadingController: LoadingController
    ) { }

    async present(backdropDismiss = false) {
        const topLoader = await this.loadingController.getTop();
        if (!topLoader) {
            this.loader = await this.loadingController.create({
                spinner: 'crescent',
                backdropDismiss,
                duration: 5000,

            });
            await this.loader.present();
        }
    }

    async dismiss() {
        if (this.loader) {
            await this.loader.dismiss();
        }
    }


}
